enum SubmitOption {
  AuthorityReviewPost = 1,
  AuthorityReviewFlex = 2,
  AuthorityReviewEmail = 3,
  AuthorityReviewOnline = 4,
}

export default SubmitOption
